"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyLiveData = applyLiveData;
const FIELD_GROUPS = ['header', 'primary', 'secondary', 'auxiliary', 'back'];
function seedValueFor(seedGroup, key) {
    if (seedGroup === undefined)
        return undefined;
    for (const f of seedGroup) {
        if (f.key === key)
            return f.value;
    }
    return undefined;
}
function applyLiveData(template, seed) {
    const fields = {};
    for (const group of FIELD_GROUPS) {
        const templateGroup = template.fields[group];
        if (templateGroup === undefined)
            continue;
        const seedGroup = seed.fields[group];
        fields[group] = templateGroup.map((field) => {
            const seedValue = seedValueFor(seedGroup, field.key);
            if (seedValue !== undefined && seedValue.trim() !== '') {
                return { ...field, value: seedValue };
            }
            return { ...field };
        });
    }
    return { ...template, fields };
}
//# sourceMappingURL=applyLiveData.js.map